var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { staticClass: "menu-bg-blue-transparent", attrs: { "no-body": "" } },
    [
      _c(
        "b-container",
        {
          staticClass: "panel-height scroll-Container",
          style: _vm.layersListMaxHeight,
        },
        [
          _c(
            "b-row",
            { staticClass: "py-2 px-2" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn btn-sm btn-dark btn-block",
                      attrs: { id: "selectAll" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleAll()
                        },
                      },
                    },
                    [
                      _vm.selectAllControl
                        ? _c("span", { staticClass: "pl-2" }, [
                            _vm._v("Deselect All"),
                          ])
                        : _c("span", { staticClass: "pl-2" }, [
                            _vm._v("Select All"),
                          ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.highwayDBcloudSubcategory, function (subCategory) {
            return _c(
              "div",
              { key: subCategory, staticClass: "pb-1" },
              [
                _c("div", { staticClass: "py-2 bg text-center" }, [
                  subCategory != undefined
                    ? _c("span", [_vm._v(_vm._s(subCategory))])
                    : _c("span", [_vm._v(_vm._s(_vm.deliveryInfo))]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.grouped[subCategory], function (layer) {
                  return _c(
                    "b-row",
                    {
                      key: layer.name,
                      staticClass: "pt-1 px-4",
                      attrs: { "align-v": "center" },
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "col-no-pad" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-sm",
                              attrs: { variant: _vm.getClass(layer.name) },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit(
                                    "toggleLayerVisibility",
                                    layer.name
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(layer.name) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "col-no-pad text-right" },
                        [
                          _vm.spinnerManager.includes(layer.name)
                            ? _c("b-spinner", {
                                attrs: { variant: "primary", small: "" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", { attrs: { src: layer.legendURL } }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }